import React from 'react';
import {Input, Select, Form, Modal, DatePicker,Upload,message,Button,Icon,Col,Row} from 'antd';
import moment from 'moment';


const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

const formLargeItemLayout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 19,
  },
}

const modalMaster = ({visible,type,item = {},onOk,onCancel,form: {getFieldDecorator,validateFields,getFieldsValue,
	},}) => {

	function handleOk () {
		validateFields((err, values) => {
		
		if(err){return }
		
	  //如果是 Select InputNumber 作为输入组件；如果不填返回的是 undefined，应该变成 null
      //if(values.cid == item.cid){delete values.cid; } else {if(typeof(values.cid)=="undefined"){values.cid = null; }}	  

		values.status='批准';
		values.approver =sessionStorage.getItem('user_name');	
		values.approver_time =new Date().getTime(); 
		
		
		if (Object.getOwnPropertyNames(values).length == 0) {
		  onCancel()
		  return
		}
	  
	  if(item.id){values.id = item.id} //如果是变更，item有内容，把id给到values

		onOk(values)      

	  })
	}
	
	
	function handleReject () {
		validateFields((err, values) => {		
		
		values.status ='拒绝';		
		values.approver =sessionStorage.getItem('user_name');	
		values.approver_time =new Date().getTime(); 
		
		if (Object.getOwnPropertyNames(values).length == 0) {
		  onCancel()
		  return
		}
	  
	  if(item.id){values.id = item.id} //如果是变更，item有内容，把id给到values

		onOk(values)      

	  })
	}

	const modalOpts = {
	  title: '审核',
	  visible,
	  onOk: handleOk,	
	  onReject:handleReject,
	  onCancel,keyboard:false,maskClosable:false,
	  wrapClassName: 'vertical-center-modal',
	  width: 520,
	  //okText: '确认',
      //cancelText: '取消',
	 
	}

	

	return (
	  <Modal {...modalOpts}>	  
		<Form layout="horizontal">		
		   
		<Form.Item label={'客户名称'} {...formItemLayout} >
		   {getFieldDecorator('cust_name', {
				initialValue: item.cust_name,
			  }
			)(
			<Input disabled={type != 'create'}/>   
			)}
		</Form.Item>         
		<Form.Item label={'授信时间'} {...formItemLayout} >
		   {getFieldDecorator('started_at', {			  
				initialValue: moment(item.started_at,'YYYYMMDD'),
				rules: [{ required: true, message: '请填写授信开始时间!' }],
			  }
			)(
			<DatePicker />
			)}
		</Form.Item>
			<Form.Item label={'授信到期时间'} {...formItemLayout} >
				{getFieldDecorator('finished_at', {
						initialValue: moment(item.finished_at,'YYYYMMDD'),
					}
				)(
					<DatePicker />
				)}
			</Form.Item>
			<Form.Item label={'授信金额'} {...formItemLayout} >
		   {getFieldDecorator('loan_credit', {
				initialValue: item.loan_credit,
				rules: [{ required: true, message: '请填银可授信的金额!' }],
			  }
			)(
			<Input  />   
			)}
		</Form.Item>         
		<Form.Item label={'SAP编码'} {...formItemLayout} >
		   {getFieldDecorator('sap_no', {
				initialValue: item.sap_no,    
				rules: [{ required: true, message: '请填写SAP系统中客户编码!' }],
			  }
			)(
			<Input  />   
			)}
		</Form.Item>     
		<Form.Item label={'金融产品'} {...formItemLayout} >
		   {getFieldDecorator('loan_product', {
				initialValue: item.loan_product,    
				rules: [{ required: false, message: '请填写大经的金融服务产品!' }],
			  }
			)(
			<Input  />   
			)}
		</Form.Item>   		
		<Row>
			<Col span={4} offset={20} ><Button type='danger' onClick={handleReject}>拒绝</Button></Col>			
		</Row>
		</Form>
	  </Modal>
	)
}


const ModalRender = Form.create()(modalMaster); 


export default ModalRender;
